module.exports = __webpack_public_path__ + "static/media/zlatko.f9e3147c.jpg";